import {api} from '../boot/axios';

/**
 * Generates a new ID that will be unique within this client.  It does this by getting the current time.  JavaScript
 * Dates are in milliseconds, but that creates a number too large for int on the Java and SQL side.  So we convert it
 * to the number of seconds. In theory, it could be possible for two new items to be created within the same second, but
 * we are not handling that edge case.
 * @returns {number}
 */
export function newID() {
  return -Math.trunc((new Date()).getTime() / 1000);
}

export function newGUID() {
  return crypto.randomUUID();
}

/**
 * This method encapsulates all the logic used for saving an item.  This includes deciding whether this will
 * be a create or update, handling offline functionality, and setting things up for a sync when back online.
 * This is the Pinia re-write of the saveItem method above that uses Vuex.
 * @param options The object containing the various options used in the method.  This is a sample:
 options = {
      saveLocally: medicationStore.saveMedicationLocally, // The Pinia local save method for the item
      item: medication, // The item to save to the DB
      postPath: 'medications/', // The path that axios will use for a post
    }
 * This assumes that the VueX store contains a commit called action_SAVE_SUCCESS
 * @returns {Promise<any>} The item that was saved.
 */
export async function saveSyncItem(options) {
  const _item = JSON.parse(JSON.stringify(options.item)); // Decouple the item
  try {
    delete _item.pending; // Remove the pending flag if it exists
    const res = await api.post(options.postPath, _item); // Try to post it
    options.saveLocally(res.data); // Save it locally
    return res.data; // Return the item
  } catch (err) {
    _item.pending = true; // set the pending flag
    options.saveLocally(_item); // Save it locally
    return _item; // Return the item
  }
}
